export const LinearProgress = {
  defaultProps: {},
  styleOverrides: {
    root: {
      borderRadius: 2,
    },
    bar: {
      borderRadius: 2,
    },
  },
};

export const CircularProgress = {
  defaultProps: {},
  styleOverrides: {
    circle: {
      strokeLinecap: 'round',
    },
  },
};
